<template>
  <v-divider></v-divider>

  <v-footer class="d-flex justify-space-between">
    <span>&copy; 2025 Benchmark Instances Project</span>

    <small>Vector graphics made by freepik and pch.vector <a href="https://de.freepik.com/"
                                                             class="text-decoration-none text-white">Freepik</a></small>

    <v-img class="ms-5" :src="require('@/assets/BMBF_gefoerdert_ger.jpg')" max-width="200"></v-img>

  </v-footer>
</template>

<style scoped>

</style>
<script setup lang="ts">
</script>